import React, { useState } from "react";
import { Stack } from "@mui/material";
import { StyledStack, StyledSubStack } from "./styles";
import { OrderTabs } from "./helper";
import { HubButton } from "../../components";

const OrdersV2LineItemsTable = ({ item, open }) => {
  const [value, setValue] = useState(1);
  const Tab = OrderTabs.find(({ id }) => id === value) || OrderTabs[0];
  const TableComponent = Tab?.TableComponent;

  return (
    <StyledSubStack>
      <Stack direction="row" gap="5px">
        {OrderTabs?.map((f) => (
          <HubButton
            key={f.id}
            label={f.label}
            variant="contained"
            size="xsmall"
            onClick={() => setValue(f.id)}
            sx={{ fontSize: 10, padding: "3px" }}
            {...(value === f.id ? {} : { color: "grey" })}
          />
        ))}
      </Stack>
      <StyledStack>
        <TableComponent id={item?.id} open={open} />
      </StyledStack>
    </StyledSubStack>
  );
};

export default OrdersV2LineItemsTable;
